import {Cell} from "exceljs";

import {mutateBorderToExcelJsFormat} from "./mutate/border";
import {mutateFillToExcelJsFormat} from "./mutate/fill";
import {mutateFontSizeToExcelJsFormat} from "./mutate/fontSize";
import {IExcelExportStyles} from "@containers/export/containers/excel/types";


export const buildStylesExcelJs = ({exportStyles, cell}: {
    exportStyles: IExcelExportStyles,
    cell: Cell
}) => {
    if (exportStyles.font) {
        cell.font = mutateFontSizeToExcelJsFormat(exportStyles.font)
    }
    if (exportStyles.border) {
        cell.border = mutateBorderToExcelJsFormat(exportStyles.border)
    }
    if (exportStyles.border) {
        cell.border = mutateBorderToExcelJsFormat(exportStyles.border)
    }
    if (exportStyles.fill) {
        cell.fill = mutateFillToExcelJsFormat(exportStyles.fill)
    }

    if (exportStyles.alignment) {
        cell.alignment = exportStyles.alignment
    }

    if (exportStyles.font) {
        cell.font = mutateFontSizeToExcelJsFormat(exportStyles.font)
    }
    if (exportStyles.numFmt) {
        cell.numFmt = exportStyles.numFmt
    }
}